
(function() {
'use strict';

function createTab( init ) {
	const fields = [
		{
			label: 		'Project Number',
			columnName: 'JobNumber',
			order:		'desc',
			type:       'project-link',
		},
		{
			label: 		'Login Date',
			columnName: 'LoginDate',
			type:       'date',
		},
		{
			label: 		'Report Date',
			columnName: 'ReportedDate',
			type:       'date',
		},
		{
			label: 		'Description',
			columnName: 'JobDescription'
		},
		{
			label: 		'Status',
			columnName: 'JobStatus'
		},
		{
			label: 		'Client',
			columnName: 'ClientName',
			type: 		'client-link',
		},
		{
			label: 		'Project Name',
			columnName: 'ProjectName',
			type: 		'project-name-link',
		},
		{
			label: 'Project Complete',
			columnName: 'ProjectComplete',
			type: 'boolean',
		},
		{
			label: 'Comment',
			columnName: 'ReportComment'
		},
	];

	const tab = this;
	init.setDataTableArgs( {

		tableId: 		'#datatable-project-status',

		// tables used by DataTables actions
		readTableName: 	'viewProjectStatusesWithSampleDates',
		editTableName: 	'tblJobs',

		primaryKey: 	'JobID',

		hasColumnFilters: 	false,
		canSearch: 			false,
		canSort:			false,
		drawWhen:           false,

		// Ajax action endpoints
		// these also serve as flags as to whether to show the editor buttons or add the autofill eventListener
		actionData:			'datatable_project_status',
		//actionAutofill:	'datatable_autofill_enter_results',
		//actionCreate:		'datatable_create_enter_results',
		actionEdit:			'datatable_edit_project_status',
		//actionRemove:		'datatable_remove_enter_results',

		// Adds additional data fields to ajax requests when drawing the table
		ajaxDataCallback : function( data, settings ) {
			const controller        = tab.controller;
			data.clientID 			= controller.client 	? controller.client.id 	: -1;
			data.projectName		= controller.projectName;
			data.projectNumber		= controller.projectNumber;
			data.jobStatus			= controller.jobStatus;
			data.sampleNumber		= controller.sampleNumber;
			data.loginDateFrom 		= controller.loginDateFrom;
			data.loginDateTo 		= controller.loginDateTo;
			data.dateReportedFrom 	= controller.dateReportedFrom;
			data.dateReportedTo 	= controller.dateReportedTo;
			return data;
		},

		fields: fields,

	} );

	init.setController( new TabControllerVue({
		el: '#project-status-datatable-filters',
		computed: {
			clients: function() {
				return LocalStorageManager.get( 'clientList' );
			},
			jobStatuses: function() {
				return LocalStorageManager.get( 'jobStatusOptions' );
			},
		},
		methods: {
			resetData() {
				this.client           = null;
				this.clientAddresses = [];
				this.projectName      = null;
				this.projectNames     = [];
				this.projectNumber    = null;
				this.projectNumbers   = [];
				this.sampleNumber     = null;
				this.sampleNumbers    = [];
				this.jobStatus        = null;
				this.loginDateFrom    = null;
				this.loginDateTo      = null;
				this.dateReportedFrom = null;
				this.dateReportedTo   = null;
				this.fetchingProjectNames   = false;
				this.fetchingSampleNumbers  = false;
				this.fetchingProjectNumbers = false;
				this.fetchingClientAddresses = false;
			},
			onOpenTab: function(){
				this.ajaxLoadProjectNames();
				this.ajaxLoadProjectNumbers();
				this.ajaxLoadSampleNumbers();
				this.ajaxLoadClientAddresses();
			},
			ajaxLoadProjectNames: function() {
				const _this = this;
				_this.fetchingProjectNames = false;

				window.ajaxCall({
					data : {
						action: 'get_project_names_by_client',
						clientId: this.client ? this.client.id : null,
					},
					onSuccess : function( response ) {
						_this.projectNames = response.data;
					},
					onError : function( response ) {
						alert( _this.client
							? 'Could not load Project Names for ' + _this.client.text
							: 'Could not load Project Names' );
					},
					onComplete : function() {
						_this.fetchingProjectNames = false;
					},
				});
			},
			ajaxLoadProjectNumbers: function() {
				const _this = this;
				_this.fetchingProjectNumbers = true;

				window.ajaxCall({
					data : {
						action: 'get_project_numbers_by_client',
						clientId: this.client ? this.client.id : null,
					},
					onSuccess : function( response ) {
						_this.projectNumbers = response.data;
					},
					onError : function( response ) {
						alert( _this.client
							? 'Could not load Project Numbers for ' + _this.client.text
							: 'Could not load Project Numbers' );
					},
					onComplete : function() {
						_this.fetchingProjectNumbers = false;
					},
				});
			},
			ajaxLoadClientAddresses: function() {
				const _this = this;
				if(this.client) {
					_this.fetchingClientAddresses = true
					window.ajaxCall({
						data : {
							action: 'get_addresses_with_parts_by_client',
							clientId: this.client ? this.client.id : null,
						},
						onSuccess : function( response ) {
							_this.clientAddresses = response.data;
						},
						onError : function( response ) {
							console.error((_this.client
							 	? 'Could not load current address data for ' + _this.client.text
							 	: 'Could not load current address data for client') + ": " + response);
						},
						onComplete : function() {
							_this.fetchingClientAddresses = false;
						},
					});
				}
			},
			ajaxLoadSampleNumbers: function() {
				const _this = this;
				_this.fetchingSampleNumbers = true;

				window.ajaxCall({
					data : {
						action: 'get_sample_numbers_by_client',
						clientId: this.client ? this.client.id : null,
					},
					onSuccess : function( response ) {
						_this.sampleNumbers = response.data;
					},
					onError : function( response ) {
						alert( _this.client
							? 'Could not load Sample Numbers for ' + _this.client.text
							: 'Could not load Sample Numbers' );
					},
					onComplete : function() {
						_this.fetchingSampleNumbers = false;
					},
				});
			},
			search() { tab.drawTable(); },
		},
		watch: {
			client: function( newValue, oldValue ) {
				this.clientAddresses = [];
				this.projectName = null;
				this.projectNames = [];
				this.projectNumber = null;
				this.projectNumbers = [];
				this.sampleNumber = null;
				this.sampleNumbers = [];
				if ( newValue ) {
					this.ajaxLoadClientAddresses();
					this.ajaxLoadProjectNames();
					this.ajaxLoadProjectNumbers();
					this.ajaxLoadSampleNumbers();
				}
			}
		}
	}) );
}

AppTabs.createTab( {
	name: 'project-status',
	icon: 'tachometer-alt',
	text: 'Project Status',
	//preload: 'vmProjectStatus',
	create: createTab,
} );

})();
